import React, { useState, Fragment, useCallback, useMemo, useEffect } from 'react';
import { StyleSheet, useWindowDimensions, ScrollView, Platform, SafeAreaView, View, TouchableOpacity } from 'react-native';
import { Calendar, LocaleConfig } from 'react-native-calendars';
import { useTheme } from '@react-navigation/native';
import { initReactI18next, useTranslation } from 'react-i18next';
import { CalendarLocale, getLocale, getMondayFirst } from '../../constants/CalendarLocale';
import CustomDropDown from '../CustomDropDown/CustomDropdown';
import CustomButton from '../CustomButton/CustomButton';
import CustomLabel from '../CustomLabel/CustomLabel';
import Arrows from '../../img/arrows';
import Ionicons from "@react-native-vector-icons/ionicons/static";


const CustomCalendar = (props) => {

  const convertSingleDigitNumberToTwoDigit = (number) => {
    return number > 9 ? "" + number : "0" + number;
  };

  //#region Function State Definitions
  var date;
  var INITIAL_DATE;
  var today;
  if (props.range?.startDate !== '')
    today = props.range?.startDate === undefined ? new Date() : new Date(props.range?.startDate);
  else
    today = new Date();

  const { t, i18n } = useTranslation();

  // if called from LAA, select given date, else select current date
  if (props.selectedDate) {
    INITIAL_DATE = new Date(props.selectedDate);
  } else {
    INITIAL_DATE = new Date();
  };
  date = INITIAL_DATE.getFullYear() + "-" + convertSingleDigitNumberToTwoDigit(INITIAL_DATE.getMonth() + 1) + "-" + convertSingleDigitNumberToTwoDigit(INITIAL_DATE.getDate());

  const [year, setYear] = useState(today.getFullYear())
  const [month, setMonth] = useState(zeroPad(today.getMonth() + 1))
  // * Years 
  const Years = Array.from({ length: 91 }, (_, i) => {
    const startYear = props.startingYear || 2010;
    const year = (startYear + i).toString();
    return { label: year, value: year };
  });

  const Months = [
    { label: t('common:jan'), value: '01' },
    { label: t('common:feb'), value: '02' },
    { label: t('common:mar'), value: '03' },
    { label: t('common:apr'), value: '04' },
    { label: t('common:may'), value: '05' },
    { label: t('common:jun'), value: '06' },
    { label: t('common:jul'), value: '07' },
    { label: t('common:aug'), value: '08' },
    { label: t('common:sep'), value: '09' },
    { label: t('common:oct'), value: '10' },
    { label: t('common:nov'), value: '11' },
    { label: t('common:dec'), value: '12' },
  ];

  const { width, height } = useWindowDimensions();
  const [selected, setSelected] = useState(date);
  const [showSelector, setShowSelector] = useState(false);
  const [monthYear, setMonthYear] = useState(Months.find(({ value }) => value === zeroPad(today.getMonth() + 1))?.label + ' ' + today.getFullYear());
  const [clickedData, setClickedData] = useState([]);
  const [selectedMutliDot, setSelectedMutliDot] = useState(date);
  const [current, setCurrent] = useState(props.range !== undefined ? (props.range.startDate === undefined ? date : props.range.startDate) : date);

  const { colors } = useTheme();
  const styles = makeStyles(colors, height, width, props);
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]

  const [{ key, theme }, setTheme] = useState({
    key: 'dark', theme: {
      calendarBackground: colors.background_card,

      selectedDayBackgroundColor: colors.calendarDotColor,
      selectedDayTextColor: colors.card_line,

      dayTextColor: colors.calendar_numbers,
      textDisabledColor: '#a1a1a1',

      monthTextColor: colors.text_secondary,
      textMonthFontWeight: 'bold',
      textSectionTitleColor: colors.calendar_numbers,

      arrowWidth: 30,
      arrowHeight: 30,
      arrowColor: colors.calendarArrow,
      todayTextColor: colors.calendarDotColor,
      dotColor: colors.calendarDotColor,

      //* Override the calendar day spacing
      'stylesheet.calendar.main': {
        week: {
          justifyContent: 'space-between',
          flexDirection: 'row',
        },
        monthView: {
          padding: 0,
          margin: 0,
        },
        // dayContainer: {
        //   flexWrap: 'wrap',
        //   flexDirection: 'column',
        //   flex: 1,
        // },
        // container: {
        //     padding: 0,
        // },
      },
    }
  })

  LocaleConfig.locales['en'] = CalendarLocale['en'];
  LocaleConfig.locales['gr'] = CalendarLocale['gr'];
  LocaleConfig.defaultLocale = i18n.language;

  function zeroPad(num) {
    return num.toString().padStart(2, "0");
  }

  //#endregion

  //#region Helper Functions
  function GetSelectedData() {
    let mrked = {};
    props.data.map(itrData => {
      let itrDate = new Date(props.isEventsScreen ? itrData.sessionStartDate : itrData.linedate)
      let colour = props.isEventsScreen ? 'blue' : (itrData.colour === null ? 'black' : itrData.colour)

      // * Format date to be accepted by calendar. In addition, take into consideration the timezone.
      let formatedDate = itrDate
      const offset = formatedDate.getTimezoneOffset();
      formatedDate = new Date(formatedDate.getTime() - (offset * 60 * 1000));
      formatedDate = formatedDate.toISOString().split('T')[0];

      if(!props.isEventsScreen) {
        if (Object.entries(mrked).length === 0) {
          mrked[formatedDate] = {
            dots: [
              { color: colour, employeePhoto: itrData.employeePhoto, teammateName: itrData.teammateName, acodeDesc: itrData.acodeDesc, approved: itrData.approved, submitted: itrData.submitted },
            ]
          };
        }
        else {
          if (formatedDate in mrked) {
            mrked[formatedDate].dots.push({ color: colour, employeePhoto: itrData.employeePhoto, teammateName: itrData.teammateName, acodeDesc: itrData.acodeDesc, approved: itrData.approved, submitted: itrData.submitted })
          }
          else {
            mrked[formatedDate] = {
              dots: [
                { color: colour, employeePhoto: itrData.employeePhoto, teammateName: itrData.teammateName, acodeDesc: itrData.acodeDesc, approved: itrData.approved, submitted: itrData.submitted },
              ]
            };
          }
        }
      } else {
        if (Object.entries(mrked).length === 0) {
          mrked[formatedDate] = {
            dots: [
              itrData
            ]
          };
        }
        else {
          if (formatedDate in mrked) {
            mrked[formatedDate].dots.push(itrData)
          }
          else {
            mrked[formatedDate] = {
              dots: [
                itrData,
              ]
            };
          }
        }
      }
    })
    return mrked;
  }

  //#endregion

  //#region UseEffect
  useEffect(() => {
    if (props.setSelectedData !== undefined)
      props.setSelectedData(clickedData);
  }, [clickedData]);

  // when navigating from LAA to team schedule, clear values
  useEffect(() => {
    if (!props.selectedDate) {
      setSelected(date);
      setClickedData([]);
      setSelectedMutliDot(date);
    }
    else {
      let mrked = GetSelectedData(props.selectedDate)
      if (mrked[props.selectedDate] !== undefined) {
        setClickedData(mrked[props.selectedDate].dots)
      } else {
        setClickedData([]);
      };
    }
  }, [props.selectedDate]);
  //#endregion

  //#region Listeners
  const onPressed = () => {
    setShowSelector(true)
  };

  const onLeftArrowPressed = () => {
    let m = zeroPad(Number(month) - 1)
    let y = year;
    if (m === '00') {
      y = zeroPad(Number(year) - 1)
      m = '12';
    }
    setMonth(m);
    setYear(y);
    setMonthYear(Months.find(({ value }) => value === m)?.label + ' ' + y)
    setCurrent(y + "-" + m + "-" + '01')
  }

  const onRightArrowPressed = () => {
    let m = zeroPad(Number(month) + 1)
    let y = year;
    if (m === '13') {
      y = zeroPad(Number(year) + 1)
      m = '01';
    }

    setMonth(m);
    setYear(y);
    setMonthYear(Months.find(({ value }) => value === m)?.label + ' ' + y)
    setCurrent(y + "-" + m + "-" + '01')
  }

  function handleDayPressRange(day) {
    // if allowSingleDate is true then only one date will be selected and not a range of dates
    if (props.allowSingleDate) {
      props.setRange({
        startDate: day.dateString,
        endDate: null
      });
    }
    else if (props.range.startDate && !props.range.endDate && day.dateString >= props.range.startDate) {
      // startDate is selected. Complete the range selection
      let newTempRange = { ...props.range, ...{ endDate: day.dateString } };
      props.setRange(newTempRange);
    }
    else {
      // startDate isn't selected. Start the range selection
      props.setRange({
        startDate: day.dateString
      });
    };
  };

  const onDayPress = useCallback((day) => {
    props.setCurrDate !== null && props.setCurrDate(monthNames[day.month - 1] + ' ' + zeroPad(day.day) + ' ' + day.year);
    setSelected(day.dateString);
    setSelectedMutliDot(day.dateString)
  }, []);

  const selectDates = () => {
    setMonthYear(Months.find(({ value }) => value === month)?.label + ' ' + year)
    setCurrent(year + "-" + month + "-" + '01')
    setShowSelector(false)
  }
  //#endregion

  //#region Marked Memos
  const marked = useMemo(() => {
    if (props.calendarType === 'RangePicker')
      return
    let mrked = {};
    props.data.map(itrData => {
      let eDate = new Date(props.isEventsScreen ? itrData.sessionStartDate : itrData.enddate)
      let itrDate = new Date(props.isEventsScreen ? itrData.sessionStartDate : itrData.startdate)
      let colour = props.isEventsScreen ? 'blue' : (itrData.colour === null ? 'black' : itrData.colour)
      while (itrDate <= eDate) {
        mrked[new Date(itrDate.getTime() + Math.abs(itrDate.getTimezoneOffset() * 60000)).toISOString().substring(0, 10)] = {
          dotColor: colour.toLowerCase(),
          marked: true
        };
        itrDate.setDate(itrDate.getDate() + 1)
      }
    })
    mrked[selected] = {
      selected: true,
      disableTouchEvent: true,
      selectedColor: colors.calendarDotColor,
      selectedTextColor: colors.text_white
    }
    return (mrked)

    // * Keep for refernce of data strucutre
    // {
    // [getDate(-1)]: {
    //   dotColor: 'red',
    //   marked: true
    // },
    // [getDate(-2)]: {
    //   dotColor: 'red',
    //   marked: true
    // },

    // [selected]: {
    //   selected: true,
    //   disableTouchEvent: true,
    //   selectedColor: 'orange',
    //   selectedTextColor: 'red'
    // }
    //};
  }, [selected]);

  const markedMutliDot = useMemo(() => {
    if (props.calendarType === 'RangePicker')
      return
    let mrked = GetSelectedData();
    if (mrked[selectedMutliDot] !== undefined) {
      setClickedData(mrked[selectedMutliDot].dots)
    } else {
      setClickedData([]);
    };
    mrked[selectedMutliDot] = {
      selected: true,
      disableTouchEvent: true,
      selectedColor: colors.calendarDotColor,
      selectedTextColor: colors.text_white,
    }
    return (mrked)

  }, [selectedMutliDot, props.data]);

  const selectedMarked = useMemo(() => {
    if (!props.range) return {};

    let start = new Date(props.range.startDate).getTime();
    let end = new Date(props.range.endDate || props.range.startDate).getTime();
    let markedRange = {};

    // mark selected range
    for (let cur = start; cur <= end; cur += 60 * 60 * 24000) {
      let curStr = new Date(cur).toISOString().substr(0, 10);
      markedRange[curStr] = {
        selected: true,
        color: colors.calendarDotColor,
        textColor: colors.text_white,
        startingDay: cur == start,
        endingDay: cur == end,
      };
    };

    return markedRange;
  }, [props.range]);
  //#endregion

  //#region Render Calendars
  const renderCalendarWithMultiDotMarkingWithList = () => {
    return (
      <View style={{alignItems: 'center'}}>
        {renderClearButton()}
        <Fragment>
          {showSelector ?
            <SafeAreaView style={styles.selector}>
              <CustomDropDown
                options={Years}
                value={year}
                setValue={setYear}
                type='CALENDAR'
              />
              <CustomDropDown
                options={Months}
                value={month}
                setValue={setMonth}
                type='CALENDAR'
              />
              <CustomButton
                onPress={() => selectDates()}
                iconName='arrow-forward-outline'
                show='CALENDAR'
                type='CALENDAR' />

            </SafeAreaView> :
            <Calendar
              key={current}
              style={styles.calendar}
              current={current}
              onPressArrowLeft={onLeftArrowPressed}
              onPressArrowRight={onRightArrowPressed}
              customHeaderTitle={
                <CustomButton
                  text={monthYear}
                  onPress={onPressed}
                  type={'CALENDAR'}
                />}
              markingType={'multi-dot'}
              onDayPress={onDayPress}
              markedDates={markedMutliDot || {}}
              theme={theme}
              renderArrow={(direction) => {
                if (direction === 'left') {
                  return <Ionicons name="arrow-back" size={24} color={colors.calendarArrow} />;
                } else if (direction === 'right') {
                  return <Ionicons name="arrow-forward" size={24} color={colors.calendarArrow} />;
                }
              }}
            />
          }
        </Fragment>
      </View>
    );
  };

  // TODO Have to restructure dropdown to avoid repeating code 
  const renderCalendarWithSelectableDate = () => {
    return (
      <>
        {renderClearButton()}
        <Fragment>
          {showSelector ?
            <SafeAreaView style={styles.selector}>
              <CustomDropDown
                options={Years}
                value={year}
                setValue={setYear}
                type='CALENDAR'
              />
              <CustomDropDown
                options={Months}
                value={month}
                setValue={setMonth}
                type='CALENDAR'
              />
              <CustomButton
                onPress={() => selectDates()}
                iconName='arrow-forward-outline'
                show='CALENDAR'
                type='CALENDAR' />
            </SafeAreaView> :
            <Calendar
              key={current}
              enableSwipeMonths
              onPressArrowLeft={onLeftArrowPressed}
              onPressArrowRight={onRightArrowPressed}
              customHeaderTitle={
                <CustomButton
                  text={monthYear}
                  onPress={onPressed}
                  type={'CALENDAR'}
                />}
              current={current}
              style={styles.calendar}
              onDayPress={onDayPress}
              markedDates={marked}
              theme={theme}
              renderArrow={(direction) => {
                if (direction === 'left') {
                  return <Ionicons name="arrow-back" size={24} color={colors.calendarArrow} />;
                } else if (direction === 'right') {
                  return <Ionicons name="arrow-forward" size={24} color={colors.calendarArrow} />;
                }
              }}
            />
          }
        </Fragment>
      </>
    );
  };

  const renderCalendarWithRangePicker = () => {
    return (
      <>
        {renderClearButton()}
        <Fragment>
          {showSelector ?
            <SafeAreaView style={styles.selector}>
              <CustomDropDown
                options={Years}
                value={year}
                setValue={setYear}
                type='CALENDAR'
              />
              <CustomDropDown
                options={Months}
                value={month}
                setValue={setMonth}
                type='CALENDAR'
              />
              <CustomButton
                onPress={() => selectDates()}
                iconName='arrow-forward-outline'
                show='CALENDAR'
                type='CALENDAR' />

            </SafeAreaView> :
            <Calendar
              key={current}
              style={styles.calendar}
              current={current}
              onPressArrowLeft={onLeftArrowPressed}
              onPressArrowRight={onRightArrowPressed}
              customHeaderTitle={
                <CustomButton
                  text={monthYear}
                  onPress={onPressed}
                  type={'CALENDAR'}
                />}
              markedDates={selectedMarked}
              markingType="period"
              onDayPress={handleDayPressRange}
              theme={theme}
              renderArrow={(direction) => {
                if (direction === 'left') {
                  return <Ionicons name="arrow-back" size={24} color={colors.calendarArrow} />;
                } else if (direction === 'right') {
                  return <Ionicons name="arrow-forward" size={24} color={colors.calendarArrow} />;
                }
              }}
            />
          }
        </Fragment>
      </>
    );
  };

  const renderExamples = () => {
    return (
      <View style={{backgroundColor: colors.background_card, alignContent: 'center', borderRadius: 10, overflow: 'hidden'}}>
        <Fragment>
          {props.calendarType === 'Multidot' && renderCalendarWithMultiDotMarkingWithList()}
          {props.calendarType === 'SelectableDate' && renderCalendarWithSelectableDate()}
          {props.calendarType === 'RangePicker' && renderCalendarWithRangePicker()}
        </Fragment>
      </View>
    );
  };

  const renderClearButton = () => {
    if (!props.setRange) return null;

    return (
      <View>
        <TouchableOpacity
          onPress={() => props.setRange({ startDate: '', endDate: '' })}
          style={{ padding: 8 }}
        >
          <CustomLabel
            value={t('common:clear')}
            type='CLEAR' />
        </TouchableOpacity>
      </View>
    );
  };
  //#endregion

  return (
    <ScrollView
      showsVerticalScrollIndicator={false}>
      {renderExamples()}
    </ScrollView>
  );
}

const makeStyles = (colors, height, width, props) => StyleSheet.create({
  calendar: {
    height: Platform.OS === 'web' ? 285 : (height < 670 ? height * 45 / 100 : height * 37 / 100), 
    width: Platform.OS === 'web' ? (props.isMyLeavesScreen ? 285 : 385) : props.calendarType === 'RangePicker' ? width * 80 / 100 : width * 90 / 100,
    borderRadius: 10,
    backgroundColor: colors.background_card,
    borderWidth: 0,
  },

  selector: {
    margin: 20,
    alignItems: 'center'
  }
});

export default CustomCalendar